import React, { memo } from "react";

import { ProductGalleryGridMedia } from "@react/sections/ProductHero/ProductGalleryGrid/ProductGalleryGridMedia.data";
import { ProductValueProps } from "@react/sections/ProductHero/ProductValueProps";
import { type CartMediaVideo, type CartMediaImage } from "@tablescape/state";
import { type TTailwindString, tw } from "classnames";

type Props = {
  lazyLoadImages: boolean;
  medias: (CartMediaImage | CartMediaVideo)[];
  showProductValueProps: (index: number) => boolean;
};

const styles = {
  base: tw(
    "grid",
    "w-full",
    "max-w-[764px]" as TTailwindString,
    "grid-cols-2",
    "gap-4"
  ),
};

const ProductGalleryGridViewBase = ({
  lazyLoadImages,
  medias,
  showProductValueProps,
}: Props) => {
  return (
    <div className={styles.base}>
      {medias.map((media, index) => (
        <React.Fragment key={`pdpGalleryGrid-media-${index}`}>
          <ProductGalleryGridMedia
            isHero={index === 0}
            lazyLoadImages={lazyLoadImages}
            media={media}
          />
          {showProductValueProps(index) && <ProductValueProps />}
        </React.Fragment>
      ))}
    </div>
  );
};

export const ProductGalleryGridView = memo(ProductGalleryGridViewBase);
